<div class="content">
    <h1>{{h1}}</h1>
    <section [innerHTML]="content"></section>
</div>
